<div class="skeleton" [ngStyle]="{ height, width }"></div>
